<template>
  <v-card class="rounded-card card-shadow" color="primary">
    <v-card-title class="white--text font-weight-bold pl-5">
      <v-icon x-large left color="white">mdi-chart-donut</v-icon>
      Acessos totais
    </v-card-title>
    <v-card-text v-if="!loading && !acessosOfertas && !acessosFornecedor"
      class="text--primary dashboard-empty-div d-flex align-center justify-center">
      <span class="white--text font-weight-bold">
        Nenhum dado encontrado para o período
      </span>
    </v-card-text>
    <v-card-text v-else
                 class="text--primary dashboard-totais">
      <div v-if="loading">
        <px-circular-loading/>
      </div>
      <div v-if="!loading && (acessosOfertas || acessosFornecedor)"
           class="d-flex flex-column justify-space-around fill-height">
        <div class="d-flex justify-space-around">
          <div class="text-center">
          <span class="white--text headline font-weight-bold">
            <template v-if="acessosOfertas">
              {{ acessosOfertas.totalAcessos }}
            </template>
            <template v-else>
              0
            </template>
          </span>
            <div class="white--text body-2">
              Acessos à ofertas
            </div>
          </div>
          <div class="text-center">
          <span class="white--text headline font-weight-bold">
            <template v-if="acessosFornecedor">
              {{ acessosFornecedor.totalAcessos }}
            </template>
            <template v-else>
              0
            </template>
          </span>
            <div class="white--text body-2">
              Acessos à sua página
            </div>
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import DashboardAcessosService from './dashboard-acessos';

export default {
  props: {
    stateDate: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      acessosOfertas: null,
      acessosFornecedor: null,
      loading: false,
    };
  },
  computed: {
    query() {
      return `data >= ${this.stateDate.initialDate} and data <= ${this.stateDate.finalDate}`;
    },
  },
  methods: {
    getTotais() {
      this.loading = true;
      Promise.all([
        DashboardAcessosService.getAcessosTotaisOferta({
          query: this.query,
        }),
        DashboardAcessosService.getAcessosTotaisFornecedor({
          query: this.query,
        }),
      ])
        .then((result) => {
          const [acessosOfertas, acessosForncedor] = result;
          this.acessosOfertas = acessosOfertas.data;
          this.acessosFornecedor = acessosForncedor.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    stateDate(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.getTotais();
    },
  },
  created() {
    this.getTotais();
  },
};
</script>

<style scoped>
.dashboard-empty-div {
  height: 280px;
}

.dashboard-totais {
  height: 280px;
}
</style>
